import React from 'react'
import { Switch, Route, useHistory } from 'react-router-dom'
import { connect } from 'react-redux'
import Auth from '../../../../Layout/Auth'
import WorkInProgress from '../../../../GlobalModules/Utility/Components/WorkInProgress'
import BookingList from '../Pages/BookingList'
import BookingView from '../Pages/BookingView'
import AddBooking from '../Pages/AddBooking'
import BookingEdit from '../Pages/BookingEdit'

function BookingEventsRoute() {
  const history = useHistory()
  return (
    <Switch>
      <Route
        exact
        path='/:lng/booking-events'
        render={() => (
          <Auth
            history={history}
            allowedRoles={['app_admin', 'admin', 'staff']}
          >
            <BookingList history={history} />
          </Auth>
        )}
      />
      <Route
        exact
        path='/:lng/booking-events/booking/view/:slack'
        render={(props) => (
          <Auth
            history={history}
            allowedRoles={['app_admin', 'admin', 'staff']}
          >
            <BookingView {...props} />
          </Auth>
        )}
      />
      <Route
        exact
        path='/:lng/booking-events/add'
        render={(props) => (
          <Auth
            history={history}
            allowedRoles={['app_admin', 'admin', 'staff']}
          >
            <AddBooking {...props} />
          </Auth>
        )}
      />
      <Route
        exact
        path='/:lng/booking-events/booking/edit/:slack'
        render={(props) => (
          <Auth
            history={history}
            allowedRoles={['app_admin', 'admin', 'staff']}
          >
            <BookingEdit {...props} />
          </Auth>
        )}
      />
      <Route
        path='/:lng/booking-events/:unknown'
        render={() => <WorkInProgress />}
      />
    </Switch>
  )
}

const mapStateToProps = (globalState) => ({
  userCredentials: globalState.LoginReducer.userCredentials,
  userEntryType: globalState.LoginReducer.userEntryType
})

export default connect(mapStateToProps)(BookingEventsRoute)
